import {setCheckOrderPassengers, setPassengerDataUpdating, setTicket} from "@CheckOrder/reducers/checkOrderSlice";
import consolidatePassengers from "@CheckOrder/api/functions/consolidatePassengers";
import {OnQueryStartedFunctionAttrType} from "@/types/generic/OnQueryStartedFunctionAttr.type";
import {
    SetActiveAddonRequestParamsType,
    SetActiveAddonResponseType
} from "@CheckOrder/api/types/SetActiveAddonQuery.type";
import {setError} from "@Reducers/pageSlice";

export default function setAddonQuery(): OnQueryStartedFunctionAttrType<SetActiveAddonRequestParamsType, SetActiveAddonResponseType> {
    return async (request, {dispatch, queryFulfilled}) => {
        dispatch(setPassengerDataUpdating(true))

        try {
            const response = await queryFulfilled

            if (response.meta.response.ok) {
                const passengers = consolidatePassengers(
                    request.passengers,
                    response.data.checkOrder.passengers
                )

                dispatch(setTicket({ticket: response.data.checkOrder.ticket, keepPassengerClasses: true}))
                dispatch(setCheckOrderPassengers(passengers))
                dispatch(setPassengerDataUpdating(false))
            }
        } catch (err) {
            dispatch(setError({
                error: `Failed to set an addon`,
                info: `ticket ${request.ticketCode}, data: ${JSON.stringify(request.selectedVehicle)}`,
            }))
            dispatch(setPassengerDataUpdating(false))
        }
    }
}